import { ContentGroup } from '@rossum/components/content-group/ContentGroup';
import { Skeleton, Stack } from '@rossum/ui/material';

const FieldsSkeleton = ({ fields }: { fields: number }) => (
  <Stack spacing={3} useFlexGap>
    {Array.from({ length: fields }, (_, index) => (
      <Skeleton key={index} variant="rounded" height={56} />
    ))}
  </Stack>
);

export const CredentialFormSkeleton = () => (
  <>
    <ContentGroup
      title={<Skeleton width={120} />}
      description={<Skeleton width="80%" />}
    >
      <FieldsSkeleton fields={3} />
    </ContentGroup>
    <ContentGroup
      title={<Skeleton width={120} />}
      description={<Skeleton width="80%" />}
    >
      <FieldsSkeleton fields={3} />
    </ContentGroup>
  </>
);
